import Axios from "../../Config/API";

import {
    ICategorias,
    IListagemDasPesquisasSatisfacao,
    IListarPesquisaSatisfacao,
    IRespostaChat,
} from "../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import Service from "../../Service";

export async function ListarCategoriasRespostaChatService() {
    return Service(
        Axios.get<Array<ICategorias>>(
            `/helpdesk/respostaschat/listarcategoriasrespostachat`
        )
    );
}

export async function DeletarCategoriasRespostaChatService(
    ID_CATEGORIA_RESPOSTA_CHAT: number
) {
    return Service(
        Axios.delete(
            `/helpdesk/respostaschat/deletarcategoria?ID_CATEGORIA_RESPOSTA_CHAT=${ID_CATEGORIA_RESPOSTA_CHAT}`
        )
    );
}

export async function GetCategoriasRespostaChatService(
    idCategoriaRespostaChat: number
) {
    return Service(
        Axios.get(
            `/helpdesk/respostaschat/getcategoriarespostachat?idCategoriaRespostaChat=${idCategoriaRespostaChat}`
        )
    );
}

export async function CadastrarCategoriasRespostaChatService(
    requestBody: ICategorias
) {
    return Service(
        Axios.post(`/helpdesk/respostaschat/cadastrarcategoria`, requestBody)
    );
}

export async function AtualizarCategoriasRespostaChatService(
    requestBody: ICategorias
) {
    return Service(
        Axios.put(`/helpdesk/respostaschat/atualizarcategoria`, requestBody)
    );
}

//resposta chat

export async function ListarRespostaChatService(
    idCategoriaRespostaChat: number
) {
    return Service(
        Axios.get<Array<IRespostaChat>>(
            `/helpdesk/respostaschat/listarrespostachat?idCategoriaRespostaChat=${idCategoriaRespostaChat}`
        )
    );
}

export async function CadastrarRespostaChatService(requestBody: IRespostaChat) {
    return Service(
        Axios.post(`/helpdesk/respostaschat/cadastrarrespostachat`, requestBody)
    );
}

export async function AtualizarRespostaChatService(requestBody: IRespostaChat) {
    return Service(
        Axios.put(`/helpdesk/respostaschat/atualizarespostachat`, requestBody)
    );
}

export async function DeletarRespostaChatService(idRespostaChat: number) {
    return Service(
        Axios.delete(
            `/helpdesk/respostaschat/deletarrespostachat?idRespostaChat=${idRespostaChat}`
        )
    );
}

export async function ListarPesquisaSatisfacaoService(
    requestBody: IListarPesquisaSatisfacao
) {
    return Service(
        Axios.post<IListagemDasPesquisasSatisfacao>(
            `/helpdesk/relatorioshelpdesk/listarrelatoriopesquisahelpdesk`,
            requestBody
        )
    );
}
